/**
 * 提取通用 FAQ 代码 - 保留 A 部分的 HTML 标签
 */
function extractUniversalFAQ() {
  const container = document.querySelector('.article-template-inner, .article-template-content, .article-template__content');
  if (!container) return [];

  const elements = Array.from(container.querySelectorAll('p, li, h2, h3, h4'));
  const faqList = [];
  const seenQuestions = new Set();
  
  let currentPair = null;
  let isCollectingAnswer = false;
  let hasReachedFAQSection = false;

const qRegex = /^\s*Q\d*[\.：:\s]\s*/i;
const aRegex = /^\s*A\d*[\.：:\s]\s*/i;
  const faqAnchorRegex = /(FAQ|FAQs|Frequently\s+asked\s+questions)/i;

  elements.forEach(el => {
    let tagName = el.tagName.toLowerCase();
    
    // 1. 定位 FAQ 区域
    if (!hasReachedFAQSection && tagName === 'h2' && faqAnchorRegex.test(el.innerText)) {
      hasReachedFAQSection = true;
      return;
    }
    if (!hasReachedFAQSection) return;

    // 2. 处理内容：保留内部 HTML 结构进行拆分
    let rawHtml = el.innerHTML.trim();
    // 针对你的结构，按 <br> 拆分是关键
    let lines = rawHtml.split(/<br\s*\/?>/i).map(l => l.trim()).filter(l => l);

    lines.forEach(line => {
      // 创建临时容器获取纯文本用于正则判定，但不破坏原 line 的 HTML
      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = line;
      let plainText = tempDiv.textContent.trim();

      if (!plainText) return;

      // 判定 Q (问题通常作为 Plain Text 存储在 Schema 的 name 字段)
      if (qRegex.test(plainText)) {
        isCollectingAnswer = false;
        let question = plainText.replace(qRegex, '').trim();
        if (question && !seenQuestions.has(question)) {
          currentPair = { q: question, a: "" };
          faqList.push(currentPair);
          seenQuestions.add(question);
        }
        return;
      }

      // 判定 A (保留 HTML)
      if (aRegex.test(plainText)) {
        isCollectingAnswer = true;
        // 核心修改：利用正则剥离 "A: " 文本前缀，但保留后续所有 HTML 标签
        // 该正则匹配行首可能存在的嵌套标签，直到找到 A: 并将其连同前面的空白删掉
        let answerHtml = line.replace(/^(<[^>]+>)*\s*A\d*[:：]\s*/i, (match, p1) => {
            // 如果 A 前面有标签（如 <span>A: ），保留那个开标签 p1
            return p1 ? p1 : ""; 
        });
        
        if (currentPair) {
          currentPair.a = answerHtml;
        }
        return;
      }

      // 累加模式（处理跨标签的答案）
      if (isCollectingAnswer && currentPair) {
        currentPair.a += (currentPair.a ? "<br>" : "") + line;
      }
    });
  });

  return faqList.filter(item => item.q && item.a);
}

function injectFAQ(data) {
  if (data.length === 0) return;
  
  const oldScript = document.getElementById('dynamic-faq-json');
  if (oldScript) oldScript.remove();

  const script = document.createElement('script');
  script.id = 'dynamic-faq-json';
  script.type = 'application/ld+json';

  // 构造 Schema 对象
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": data.map(item => ({
      "@type": "Question",
      "name": item.q, // 问题保持纯文本
      "acceptedAnswer": { 
        "@type": "Answer", 
        "text": item.a // 答案保留 HTML 标签
      }
    }))
  };

  script.text = JSON.stringify(jsonLd);
  document.head.appendChild(script);
  
  // --- 监控代码 ---
  // console.group("FAQ 注入监控 (带标签模式)", "color: #ff9800; font-weight: bold;");
  // console.log(`监测到页面路径: ${window.location.pathname}`);
  // console.log(`成功提取 FAQ 数量: ${data.length}`);
  // console.table(data); // 控制台表格会显示 <b>...</b> 等标签内容
  // console.groupEnd();
}

// 执行
injectFAQ(extractUniversalFAQ()); 